import { axiosInstance } from "@/apis/core";
import {
  IS_DEMO_MODE,
  demoCommunities,
  demoGarrets,
  demoLeafs,
} from "@/dummy/demo";

/**
 * 조직 구성 : 캠퍼스(Campus) / 공동체(Community) / 다락방(garret) / 순(leaf)
 * 현재 평택 온누리교회만 있으므로 캠퍼스는 "PTK"로 고정
 */

// 캠퍼스 별 공동체 리스트 가져오기
export const fetchCommunity = async () => {
  if (IS_DEMO_MODE) {
    return demoCommunities;
  }

  try {
    const res = await axiosInstance.get(
      `/user-service/api/v1/community/list?cpsCd=PTK`,
    );

    return res.data;
  } catch (error) {
    console.log(error);
  }
};

// 공동체 별 다락방 목록 가져오기
export const fetchGarret = async (cmtCd: string) => {
  if (IS_DEMO_MODE) {
    return demoGarrets.filter(g => g.cmtCd === cmtCd);
  }

  try {
    const res = await axiosInstance.get(
      `/user-service/api/v1/garret/list?cpsCd=PTK&cmtCd=${cmtCd}`,
    );

    return res.data;
  } catch (error) {
    console.log(error);
  }
};

// 다락방 별 순 목록 가져오기
export const fetchLeaf = async (cmtCd: string, garCd: string) => {
  if (IS_DEMO_MODE) {
    return demoLeafs.filter(l => l.cmtCd === cmtCd && l.garCd === garCd);
  }

  try {
    const res = await axiosInstance.get(
      `/user-service/api/v1/leaf/list?cpsCd=PTK&cmtCd=${cmtCd}&garCd=${garCd}`,
    );

    return res.data;
  } catch (error) {
    console.log(error);
  }
};

// Dropdown 등에서 쓰는 { id, name } 옵션 형태
export type OrgOption = { id: string; name: string };

// 공동체 목록을 { id, name } 옵션으로 변환 (실패 시 빈 배열)
export const fetchCommunityOptions = async (): Promise<OrgOption[]> => {
  const list = (await fetchCommunity()) ?? [];

  return list.map((item: any) => ({ id: item.cmtCd, name: item.cmtNm }));
};

// 다락방 목록을 { id, name } 옵션으로 변환 (실패 시 빈 배열)
export const fetchGarretOptions = async (
  cmtCd: string,
): Promise<OrgOption[]> => {
  const list = (await fetchGarret(cmtCd)) ?? [];

  return list.map((item: any) => ({ id: item.garCd, name: item.garNm }));
};

// 순 목록을 { id, name } 옵션으로 변환 (실패 시 빈 배열)
export const fetchLeafOptions = async (
  cmtCd: string,
  garCd: string,
): Promise<OrgOption[]> => {
  const list = (await fetchLeaf(cmtCd, garCd)) ?? [];

  return list.map((item: any) => ({ id: item.leafCd, name: item.leafNm }));
};
